export const getIsProduction = () => {
    const { host } = window.location;
    const allowedHosts = ['imagomp.seequent.com'];

    return allowedHosts.includes(host);
};
